// extracted by mini-css-extract-plugin
export default {"datePicker":"styles_datePicker__eg0Jd"};